export const SELECT_CONTENT = 'SELECT_CONTENT'
export const SELECT_ALL_CONTENT = 'SELECT_ALL_CONTENT'
export const CLEAR_SELECTED_CONTENT = 'CLEAR_SELECTED_CONTENT'
